import L from "leaflet";

export function createHighlightLayerManager(map) {
  let activeHighlight = null;

  function clear() {
    if (activeHighlight) {
      map.removeLayer(activeHighlight);
      activeHighlight = null;
    }
  }

  function attachHighlight(layer) {
    const onClick = (e) => {
      clear(); // Limpia el highlight previo

      // Verifica si la capa es de tipo Marker o CircleMarker
      if (layer instanceof L.Marker || layer instanceof L.CircleMarker) {
        activeHighlight = L.circleMarker(layer.getLatLng(), {
          radius: 14,
          color: "#1976d2",
          weight: 4,
          opacity: 1,
          fillOpacity: 0,
          interactive: false
        }).addTo(map);

        if (activeHighlight.bringToFront) activeHighlight.bringToFront();
        return;
      }

      // Si la capa es de tipo GeoJSON (por ejemplo, polígonos)
      const gj = layer.toGeoJSON();
      activeHighlight = L.geoJSON(gj, {
        interactive: false,
        style: {
          color: "#1976d2",
          weight: 1.5,
          fillOpacity: 0
        }
      }).addTo(map);

      if (activeHighlight.bringToFront) activeHighlight.bringToFront();
    };

    const onDblClick = (e) => {
      clear();
      L.DomEvent.stop(e); // Evita la propagación del evento
    };

    // Agregar eventos de clic y doble clic a la capa
    layer.on("click", onClick);
    layer.on("dblclick", onDblClick);

    return function dispose() {
      layer.off("click", onClick);
      layer.off("dblclick", onDblClick);
    };
  }

  function destroy() {
    clear();
  }

  return { attachHighlight, clear, destroy };
}

